import useSWR from 'swr';
import { fetcher } from '@shared/fetcher';
import { CategorySchema, ICategory } from '@shared/types.ts';
import { CategoryCardProps } from '@ui/category/category-card.tsx';
import { useNavigate } from 'react-router-dom';

async function fetchAllCategories(url: string) {
  const res = await fetcher.get<{ data: ICategory[] }>(url).catch(() => null);
  if (!res?.data) return undefined;
  return res?.data.data.filter((i) => CategorySchema.isValidSync(i));
}

export function useCategories() {
  const { data, isLoading } = useSWR('/api/categories', fetchAllCategories);

  const navigate = useNavigate();

  const mapped = data?.map<CategoryCardProps | undefined>((categoryItem) => {
    return {
      image: categoryItem.mobile_image || undefined,
      title: categoryItem.name,
      isLoading: false,
      onPress: () =>
        navigate(`/category/${categoryItem.id}?ct=${categoryItem.name}`),
    };
  });

  const mappedDesktop = data?.map<CategoryCardProps | undefined>(
    (categoryItem) => {
      return {
        image: categoryItem.image || undefined,
        title: categoryItem.name,
        isLoading: false,
        onPress: () =>
          navigate(`/category/${categoryItem.id}?ct=${categoryItem.name}`),
      };
    }
  );

  const array = Array(10)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: mapped || array,
    mappedDesktop: mappedDesktop || array,
    rawData: data,
    isLoading,
  };
}
